import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgValidation(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M12 0a8 8 0 110 16 8 8 0 010-16zm2.592 4.07L12 6.66 9.408 4.07a.237.237 0 00-.334 0L8.069 5.073a.236.236 0 000 .335L10.661 8l-2.592 2.592a.236.236 0 000 .334l1.005 1.005a.236.236 0 00.334 0L12 9.339l2.592 2.592a.237.237 0 00.335 0l1.004-1.005a.237.237 0 000-.334L13.339 8l2.592-2.592a.237.237 0 000-.334l-1.004-1.005a.237.237 0 00-.335 0z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Validation')(SvgValidation);
